import { Component, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { Router, Event, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationStart, NavigationEnd } from '@angular/router';
import { UiService } from './services/ui/ui.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewChecked {

  constructor(
    public ui: UiService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.ui.loader.show();
      } else if (event instanceof RouteConfigLoadEnd) {
        this.ui.loader.hide();
      }
    });

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/app.component.ts